<template>
  <div class="new_email_validation">
    <header-component
      :is-soon="false"
      :backRoute="true"
      img-left="/trocachip/img/setinha-left-preto.svg"
      img-right="/trocachip/img/access.png"
      class="header-component"
    />

    <div class="page_content">
      <h2
        class="email_title"
        :class="{ 'ac-color-white': ac }"
        v-html="emailValidationPageMessages.title"
        v-if="!requestEmail()"
      ></h2>
      <h2
        class="email_title"
        :class="{ 'ac-color-white': ac }"
        v-html="emailValidationPageMessages.titleRequestEmail"
        v-if="requestEmail()"
      ></h2>
      <p
        class="email_description"
        :class="{ 'ac-color-white': ac }"
        v-html="emailValidationPageMessages.subTitleEmail"
        v-if="!requestEmail()"
      ></p>
      <p
        class="email_description"
        :class="{ 'ac-color-white': ac }"
        v-html="emailValidationPageMessages.subtitleRequestEmail"
        v-if="requestEmail()"
      ></p>
      <p
        class="email_description"
        :class="{ 'ac-color-white': ac }"
        v-if="!isEligible"
        v-html="emailValidationPageMessages.description"
      ></p>
      <p
        class="description_dependente"
        :class="{ 'ac-color-white': ac }"
        v-if="isDependent()"
        v-html="emailValidationPageMessages.descriptionDependente"
      ></p>

      <section class="email_subtitle" v-if="!isEligible || isDependent()">
        <strong v-html="emailValidationPageMessages.yellowCardMessage"></strong>
        <br />
        <label>{{ customer.email.toLowerCase() }}</label>
      </section>

      <div class="email_value" v-else>
        <label
          :class="{ 'ac-color-white': ac, 'red-letter': errors.invalid }"
          >{{ emailValidationPageMessages.inputLabel }}</label
        >
        <div class="input-with-button">
          <input
            id="emailField"
            ref="emailInput"
            type="text"
            autocapitalize="none"
            @blur="validateEmail()"
            @keydown="cleanErrors()"
            @input="transformLowerCase"
            v-model="email"
            :placeholder=emailValidationPageMessages.inputPlaceholder
            :class="{
              'ac-color-white': ac,
              'ac-input': ac,
              'red-line': errors.invalid,
            }"
            :disabled="!editedEmail"
          />
          <button @click="editEmail()" class="edit-button">
            <img src="/trocachip/img/pencil.svg" alt="Editar email" />
          </button>
        </div>
        <span
          id="errorIncompleteEmail"
          v-if="errors.invalid"
          class="error-danger"
          :class="{ 'ac-color-yellow': ac }"
          >{{ emailValidationPageMessages.invalidEmailError }}</span
        >
      </div>

      <section class="expiration_info_card">
        <div>
          <span v-html="emailValidationPageMessages.infoDescription"></span>
          <img src="/trocachip/img/notifications-info.svg" />
        </div>
      </section>
      <div class="next_submit">
        <button
          id="submitEmail"
          class="btn_next"
          :class="{
            btn_next_active: isValid,
            'ac-border-yellow': ac,
            'ac-color-yellow': ac,
            'ac-bg-gray': ac,
          }"
          :disabled="!isValid"
          @click="next"
        >
          <loader-bottom v-if="loader" />
          <span v-if="!loader">Continuar</span>
        </button>
      </div>
    </div>

    <alert
      v-if="alert.open"
      :description="alert.description"
      :message="alert.message"
      :action="alert.action"
      :success="alert.type == 'success' ? true : false"
      :danger="alert.type == 'danger' ? true : false"
      :warning="alert.type == 'alert' ? true : false"
      :actionTrigger="alert.actionTrigger"
      :loadingProp="loading"
      @close="alert.open = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderComponent from "../components/HeaderComponent.vue";
import Alert from "../components/Alert.vue";
import trackEvent from "../services/trackEvent";
import BillingProfile from "../services/billingProfile";
import EmailVerification from "../services/emailVerification";
import { webCrypto } from "../utils/aesencryption";

export default {
  name: "NewEmailValidation",
  components: { HeaderComponent, Alert },
  data() {
    return {
      email: "",
      newEmail: "",
      editedEmail: false,
      errors: {},
      loader: false,
      alert: {
        open: false,
      },
      updateEmailConfigMutable: {},
      inclusionEmailConfigMutable: {},
      successEmailConfigMutable: {},
      emailUpdateSuccessConfigMutable: {},
      loading: false,
      isValid: false,
      isEligible: true,
    };
  },
  watch: {
    email: function () {
      if (this.email) {
        this.validateEmail();
      }
    },
  },
  created() {
    this.$store.dispatch("disableBack", true)
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
    if (this.isDependent()) {
    this.sendTracker("scren_dependente_alterar_email", 3);
    }
    this.updateEmailConfigMutable = this.updateEmailConfig;
    this.inclusionEmailConfigMutable = this.includeEmailConfig;
    this.successEmailConfigMutable = this.successEmailConfig;
    this.emailUpdateSuccessConfigMutable = this.emailUpdateSuccessConfig;
    this.errorUpdateEmailModalConfigMutable = this.errorUpdateEmailModalConfig;
    this.email = this.maskEmail(this.customer.email);
    this.isEligible =
      localStorage.getItem("@trocachip/email-eligibility") !== "false";
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      config: (state) => state.config,
      customer: (state) => state.customer,

      updateEmailConfig: (state) => state.config.updateEmailModal,
      includeEmailConfig: (state) => state.config.includeEmailModal,
      emailUpdateSuccessConfig: (state) => state.config.emailUpdateSuccessModal,
      successEmailConfig: (state) => state.config.successUpdateEmailModal,
      emailValidationPageMessages: (state) => state.config.newEmailValidation,
      errorUpdateEmailModalConfig: (state) =>
        state.config.errorUpdateEmailModal,
      finishingTitles: (state) => state.config.finishingTitles,
      enableFlagEsim: (state) => state.config.enableFlagEsim,
    }),
  },
  filters: {
    maskOnEmail(email, editedEmail) {
      let [firstPart, ...rest] = email.split("@");
      const firstPartMiddleSize = firstPart.length / 2;
      let stringToReplace = "";

      for (let i = firstPartMiddleSize; i < firstPart.length; i++) {
        stringToReplace += "*";
      }

      firstPart = firstPart.replace(
        firstPart.substring(firstPartMiddleSize, firstPart.length),
        stringToReplace
      );

      return !editedEmail ? [...firstPart, "@", ...rest].join("") : email;
    },
  },
  methods: {
    requestEmail() {
      return this.customer.requestEmail;
    },
    editEmail() {
      this.editedEmail = true;
      this.email = this.customer.email;
      setTimeout(() => this.$refs.emailInput.focus(), 50);
    },
    userHasEmail() {
      return this.customer.email;
    },
    cleanErrors() {
      this.errors.invalid = false;
    },
    maskEmail(email) {
      if (!email) return "";
      let [firstPart, ...rest] = email.split("@");
      const firstPartMiddleSize = firstPart.length / 2;
      let stringToReplace = "";

      for (let i = firstPartMiddleSize; i < firstPart.length; i++) {
        stringToReplace += "*";
      }

      firstPart = firstPart.replace(
        firstPart.substring(firstPartMiddleSize, firstPart.length),
        stringToReplace
      );

      return [...firstPart, "@", ...rest].join("");
    },
    proceed() {
      if (this.enableFlagEsim && this.$store.getters.getFlowEsim) {
        this.$router.push({
          name: "finishingScreen",
          params: {
            title: this.finishingTitles.processingTitle,
            changeEmail: false,
          },
        });
      } else if (
        this.$store.getters.getFlowSelected == "chipToESim" ||
        this.$store.getters.getFlowSelected == "eSimToESim"
      ) {
        this.sendTracker("email validado continuar");
        this.$router.push({ name: "loading-page" });
      } else {
        this.$router.push({ name: "instrucoes-barcode" });
      }
    },
    next() {
      if (this.isDependent()) {
        this.sendTracker("dependente_alterar_email_continuar")
      } else {
      this.sendTracker("confirmar email continuar");
      }
      if (!this.userHasEmail()) {
        this.openIncludeEmailModal();
        return;
      }

      if (this.editedEmail) {
        if (this.customer.email.toLowerCase() != this.email) {
          this.openUpdateEmailModal();
          return;
        }
      }

      this.openValidationSuccessModal();
    },
    openValidationSuccessModal() {
      this.successEmailConfigMutable.message =
        this.successEmailConfigMutable.message.replace(
          /\{(.+?)\}/g,
          "[" + this.email + "]"
        );

      this.alert = {
        open: true,
        actionTrigger: () => this.proceed(),
        ...this.successEmailConfigMutable,
      };
    },
    openIncludeEmailModal() {
      this.inclusionEmailConfigMutable.message =
        this.inclusionEmailConfigMutable.message.replace(
          /\{(.+?)\}/g,
          this.email
        );
      this.sendTracker("confirmar inclusao email", 3);
      this.alert = {
        open: true,
        actionTrigger: () => this.makeEmailUpdate(),
        ...this.inclusionEmailConfigMutable,
      };
    },
    nextRoute() {
      console.log("Flag Enable Esim "+this.enableFlagEsim+ " flag flow esim "+this.$store.getters.getFlowEsim);
      if (this.enableFlagEsim && this.$store.getters.getFlowEsim) {
        this.$store.dispatch("allowChangeEmail")
        this.$router.push({
          name: "finishingScreen",
          params: {
            title: this.finishingTitles.processingTitle,
            changeEmail: true,
            email: this.email,
          },
        });
      } else {
        this.loading = true;
        BillingProfile.updateEmail(this.email).then((response) => {
          this.loading = false;
          const responseData = response.data;

          if (!responseData) return;

          responseData.interactionProtocol != ""
            ? this.openSuccesUpdateEmail(responseData.interactionProtocol)
            : this.openModalErrorUpdateEmail();
        });
        this.description == this.includeEmailConfig.description
          ? this.sendTracker("confirmar alteracao email continuar")
          : this.sendTracker("confirmar inclusao email continuar");
      }
    },
    openUpdateEmailModal() {
      this.updateEmailConfigMutable.message = this.email.toLowerCase();
      this.sendTracker("confirmar alteracao email", 3);
      this.alert = {
        open: true,
        actionTrigger: () => this.makeEmailUpdate(),
        ...this.updateEmailConfigMutable,
      };
    },
    openModalErrorUpdateEmail() {
      this.alert = {
        open: true,
        actionTrigger: () => (this.alert.open = false),
        ...this.errorUpdateEmailModalConfigMutable,
      };
    },
    openSuccesUpdateEmail(protocol) {
      this.sendTracker("email validado", 3);
      if (!this.userHasEmail()) {
        this.emailUpdateSuccessConfigMutable.description =
          this.emailUpdateSuccessConfigMutable.titleInsert;
        this.emailUpdateSuccessConfigMutable.message =
          this.emailUpdateSuccessConfigMutable.message.replace(
            /\{(.+?)\}/g,
            protocol
          );
      } else {
        this.emailUpdateSuccessConfigMutable.description =
          this.emailUpdateSuccessConfigMutable.titleUpdate;
        this.emailUpdateSuccessConfigMutable.message =
          this.emailUpdateSuccessConfigMutable.message.replace(
            /\{(.+?)\}/g,
            protocol
          );
      }

      this.alert = {
        open: true,
        actionTrigger: () => this.proceed(),
        ...this.emailUpdateSuccessConfigMutable,
      };
    },
    async makeEmailUpdate() {
      const key = process.env.VUE_APP_CONFIG_AES_CRYPT_KEY;
      const cipherText = await webCrypto.simpleEncrypt(this.email, key);
      const isValid = await EmailVerification.verifyEmail(cipherText);
      if (isValid) {
      this.description == this.includeEmailConfig.description
        ? this.sendTracker("confirmar alteracao email continuar")
        : this.sendTracker("confirmar inclusao email continuar");
      this.nextRoute();
      } else {
        this.openModalErrorUpdateEmail();
      }
    },
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.errors.invalid = !emailRegex.test(this.email);
      this.isValid = !this.errors.invalid;
    },
    sendTracker(eventLabel, eventAction = 2) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": 6,
        "event-label": eventLabel,
        "event-location": "mvp esim",
        "event-value": this.customer.isExOiCustomer ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": eventAction,
      });
    },
    transformLowerCase() {
      this.email = this.email.toLowerCase();
    },
    isDependent() {
      return this.emailValidationPageMessages.plansDependent.includes(
        this.customer.planCode
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.new_email_validation {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  z-index: -1;
  > .page_content {
    margin: 25% 0%;
    > .email_title {
      font-family: "timsans_thin";
      font-size: 1.5rem;
      line-height: 1.875rem;
      text-align: center;
    }
    > .email_description {
      font-family: "timsans_regular";
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      color: #696969;
    }

    > .description_dependente {
      font-family: "timsans_regular";
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      color: #696969;
    }

    > .email_subtitle {
      font-family: "timsans_regular";
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      margin-top: 40px;
      margin-bottom: 40px;
      > label {
        color: #696969;
      }
    }
    > .next_submit {
      margin: 60px auto 40px auto;
    }
    > .email_value {
      width: 252px;
      height: auto;
      display: block;
      margin: 32px auto 0 auto;
      position: relative;

      > label {
        width: 100%;
        height: 15px;
        font-family: "timsans_regular";
        font-size: 0.75em;
        color: #6c6c6c;
      }

      .input-with-button {
        display: flex;
        align-items: center;
        position: relative;
      }

      .input-with-button p {
        width: 100%;
        font-size: 12px;
        font-family: "timsans_regular";
        color: #000000;
      }

      .input-with-button .edit-button {
        background: none;
        border: none;
        padding: 0;
        margin: 0;
        cursor: pointer;
        position: absolute;
        right: 0;
      }
    }
  }
}
.expiration_info_card {
  box-sizing: border-box;
  margin: 36px 0 0 0;
  > div {
    display: flex;
    padding: 1.5rem;
    justify-content: space-between;
    background-color: #f0f1f2;
    align-items: flex-start;
    font-family: "timsans_regular";
    font-size: 14px;
    line-height: 21x;
  }
}
.red-letter {
  color: #ff0000 !important;
}
.red-line {
  border-bottom: 1px solid #ff0000 !important;
}
</style>